// src/dataProvider/resources/trainingTemplates.ts
import { httpClient } from "../../httpClient";
import { pickClubId } from "../clubScope";

const apiUrl = "/api";

export function trainingTemplatesResource(clubId: number | null) {
  return {
    create: async (params: any) => {
      const effectiveClubId = pickClubId(params, clubId);
      if (!effectiveClubId) throw new Error("clubId fehlt (bitte Verein auswählen)");

      const { json } = await httpClient(`${apiUrl}/training-templates?club_id=${effectiveClubId}`, {
        method: "POST",
        body: JSON.stringify(params.data),
      });
      return { data: json };
    },

    clone: async (params: any) => {
      const effectiveClubId = pickClubId(params, clubId);
      if (!effectiveClubId) throw new Error("clubId fehlt (bitte Verein auswählen)");

      const { sourceId, name } = params.data;
      const { json } = await httpClient(
        `${apiUrl}/training-templates/${sourceId}/clone?club_id=${effectiveClubId}`,
        { method: "POST", body: JSON.stringify({ name }) }
      );

      const record = json?.data ?? json;
      return { data: record };
    },

    getTeams: async (params: any) => {
      const effectiveClubId = clubId;
      if (!effectiveClubId) throw new Error("clubId fehlt (bitte Verein auswählen)");

      const templateId = params.id;
      const { json } = await httpClient(
        `${apiUrl}/training-templates/${templateId}/teams?clubId=${effectiveClubId}`
      );
      return { data: { id: templateId, ...(json ?? {}) } };
    },

    setTeams: async (params: any) => {
      const effectiveClubId = clubId;
      if (!effectiveClubId) throw new Error("clubId fehlt (bitte Verein auswählen)");

      const templateId = params.id;
      const team_ids = params.data?.team_ids ?? [];

      const { json } = await httpClient(
        `${apiUrl}/training-templates/${templateId}/teams?clubId=${effectiveClubId}`,
        { method: "PUT", body: JSON.stringify({ team_ids }) }
      );
      return { data: { id: templateId, ...(json ?? {}) } };
    },
  };
}
